import {IconButton} from "@mui/material";
import React from "react";

interface SETableIconButtonProps {
    onClick: () => void,
    children: React.ReactNode
}

const SETableIconButton: React.FC<SETableIconButtonProps> = ({children, onClick}) => {
    return (
        <div style={{
            border: '1px solid #EBEBF0',
            borderRadius: '4px',
            margin: '2px',
            width: '32px',
            height: '32px',
            display: "flex",
            justifyContent: 'center'
        }}>
            <IconButton onClick={onClick}>
                {children}
            </IconButton>
        </div>
    )
}

export default SETableIconButton
